// All 52 cards
export const cardImages = {
  //hidden
   'hidden-hidden': require('../../assets/cards/hidden/hidden.png'),
   // CLUB CARDS
  'c-A': require('../../assets/cards/c/A.png'),
  'c-K': require('../../assets/cards/c/K.png'),
  'c-Q': require('../../assets/cards/c/Q.png'),
  'c-J': require('../../assets/cards/c/J.png'),
  'c-T': require('../../assets/cards/c/T.png'),
  'c-9': require('../../assets/cards/c/9.png'),
  'c-8': require('../../assets/cards/c/8.png'),
  'c-7': require('../../assets/cards/c/7.png'),
  'c-6': require('../../assets/cards/c/6.png'),
  'c-5': require('../../assets/cards/c/5.png'),
  'c-4': require('../../assets/cards/c/4.png'),
  'c-3': require('../../assets/cards/c/3.png'),
  'c-2': require('../../assets/cards/c/2.png'),

  // WHITE CLUB 
  'w-c-A': require('../../assets/cards/white/c/A.png'),
  'w-c-K': require('../../assets/cards/white/c/K.png'),
  'w-c-Q': require('../../assets/cards/white/c/Q.png'),
  'w-c-J': require('../../assets/cards/white/c/J.png'),
  'w-c-T': require('../../assets/cards/white/c/T.png'),
  'w-c-9': require('../../assets/cards/white/c/9.png'),
  'w-c-8': require('../../assets/cards/white/c/8.png'),
  'w-c-7': require('../../assets/cards/white/c/7.png'),
  'w-c-6': require('../../assets/cards/white/c/6.png'),
  'w-c-5': require('../../assets/cards/white/c/5.png'),
  'w-c-4': require('../../assets/cards/white/c/4.png'),
  'w-c-3': require('../../assets/cards/white/c/3.png'),
  'w-c-2': require('../../assets/cards/white/c/2.png'),

  // OFFWHITE CLUB
  'o-c-A': require('../../assets/cards/offwhite/c/A.png'),
  'o-c-K': require('../../assets/cards/offwhite/c/K.png'),
  'o-c-Q': require('../../assets/cards/offwhite/c/Q.png'),
  'o-c-J': require('../../assets/cards/offwhite/c/J.png'),
  'o-c-T': require('../../assets/cards/offwhite/c/T.png'),
  'o-c-9': require('../../assets/cards/offwhite/c/9.png'),
  'o-c-8': require('../../assets/cards/offwhite/c/8.png'),
  'o-c-7': require('../../assets/cards/offwhite/c/7.png'),
  'o-c-6': require('../../assets/cards/offwhite/c/6.png'),
  'o-c-5': require('../../assets/cards/offwhite/c/5.png'),
  'o-c-4': require('../../assets/cards/offwhite/c/4.png'),
  'o-c-3': require('../../assets/cards/offwhite/c/3.png'),
  'o-c-2': require('../../assets/cards/offwhite/c/2.png'),

  // GOLD CLUB
  'g-c-A': require('../../assets/cards/gold/c/A.png'),
  'g-c-K': require('../../assets/cards/gold/c/K.png'),
  'g-c-Q': require('../../assets/cards/gold/c/Q.png'),
  'g-c-J': require('../../assets/cards/gold/c/J.png'),
  'g-c-T': require('../../assets/cards/gold/c/T.png'),
  'g-c-9': require('../../assets/cards/gold/c/9.png'),
  'g-c-8': require('../../assets/cards/gold/c/8.png'),
  'g-c-7': require('../../assets/cards/gold/c/7.png'),
  'g-c-6': require('../../assets/cards/gold/c/6.png'),
  'g-c-5': require('../../assets/cards/gold/c/5.png'),
  'g-c-4': require('../../assets/cards/gold/c/4.png'),
  'g-c-3': require('../../assets/cards/gold/c/3.png'),
  'g-c-2': require('../../assets/cards/gold/c/2.png'),

  //SPADES

  's-A': require('../../assets/cards/s/A.png'),
  's-K': require('../../assets/cards/s/K.png'),
  's-Q': require('../../assets/cards/s/Q.png'),
  's-J': require('../../assets/cards/s/J.png'),
  's-T': require('../../assets/cards/s/T.png'),
  's-9': require('../../assets/cards/s/9.png'),
  's-8': require('../../assets/cards/s/8.png'),
  's-7': require('../../assets/cards/s/7.png'),
  's-6': require('../../assets/cards/s/6.png'),
  's-5': require('../../assets/cards/s/5.png'),
  's-4': require('../../assets/cards/s/4.png'),
  's-3': require('../../assets/cards/s/3.png'),
  's-2': require('../../assets/cards/s/2.png'),

  // WHITE SPADES
  'w-s-A': require('../../assets/cards/white/s/A.png'),
  'w-s-K': require('../../assets/cards/white/s/K.png'),
  'w-s-Q': require('../../assets/cards/white/s/Q.png'),
  'w-s-J': require('../../assets/cards/white/s/J.png'),
  'w-s-T': require('../../assets/cards/white/s/T.png'),
  'w-s-9': require('../../assets/cards/white/s/9.png'),
  'w-s-8': require('../../assets/cards/white/s/8.png'),
  'w-s-7': require('../../assets/cards/white/s/7.png'),
  'w-s-6': require('../../assets/cards/white/s/6.png'),
  'w-s-5': require('../../assets/cards/white/s/5.png'),
  'w-s-4': require('../../assets/cards/white/s/4.png'),
  'w-s-3': require('../../assets/cards/white/s/3.png'),
  'w-s-2': require('../../assets/cards/white/s/2.png'),

  // OFFWHITE SPADES
  'o-s-A': require('../../assets/cards/offwhite/s/A.png'),
  'o-s-K': require('../../assets/cards/offwhite/s/K.png'),
  'o-s-Q': require('../../assets/cards/offwhite/s/Q.png'),
  'o-s-J': require('../../assets/cards/offwhite/s/J.png'),
  'o-s-T': require('../../assets/cards/offwhite/s/T.png'),
  'o-s-9': require('../../assets/cards/offwhite/s/9.png'),
  'o-s-8': require('../../assets/cards/offwhite/s/8.png'),
  'o-s-7': require('../../assets/cards/offwhite/s/7.png'),
  'o-s-6': require('../../assets/cards/offwhite/s/6.png'),
  'o-s-5': require('../../assets/cards/offwhite/s/5.png'),
  'o-s-4': require('../../assets/cards/offwhite/s/4.png'),
  'o-s-3': require('../../assets/cards/offwhite/s/3.png'),
  'o-s-2': require('../../assets/cards/offwhite/s/2.png'),

  // GOLD SPADES
  'g-s-A': require('../../assets/cards/gold/s/A.png'),
  'g-s-K': require('../../assets/cards/gold/s/K.png'),
  'g-s-Q': require('../../assets/cards/gold/s/Q.png'),
  'g-s-J': require('../../assets/cards/gold/s/J.png'),
  'g-s-T': require('../../assets/cards/gold/s/T.png'),
  'g-s-9': require('../../assets/cards/gold/s/9.png'),
  'g-s-8': require('../../assets/cards/gold/s/8.png'),
  'g-s-7': require('../../assets/cards/gold/s/7.png'),
  'g-s-6': require('../../assets/cards/gold/s/6.png'),
  'g-s-5': require('../../assets/cards/gold/s/5.png'),
  'g-s-4': require('../../assets/cards/gold/s/4.png'),
  'g-s-3': require('../../assets/cards/gold/s/3.png'),
  'g-s-2': require('../../assets/cards/gold/s/2.png'),

  //Diamonds

  'd-A': require('../../assets/cards/d/A.png'),
  'd-K': require('../../assets/cards/d/K.png'),
  'd-Q': require('../../assets/cards/d/Q.png'),
  'd-J': require('../../assets/cards/d/J.png'),
  'd-T': require('../../assets/cards/d/T.png'),
  'd-9': require('../../assets/cards/d/9.png'),
  'd-8': require('../../assets/cards/d/8.png'),
  'd-7': require('../../assets/cards/d/7.png'),
  'd-6': require('../../assets/cards/d/6.png'),
  'd-5': require('../../assets/cards/d/5.png'),
  'd-4': require('../../assets/cards/d/4.png'),
  'd-3': require('../../assets/cards/d/3.png'),
  'd-2': require('../../assets/cards/d/2.png'),

  // WHITE DIAMONDS
  'w-d-A': require('../../assets/cards/white/d/A.png'),
  'w-d-K': require('../../assets/cards/white/d/K.png'),
  'w-d-Q': require('../../assets/cards/white/d/Q.png'),
  'w-d-J': require('../../assets/cards/white/d/J.png'),
  'w-d-T': require('../../assets/cards/white/d/T.png'),
  'w-d-9': require('../../assets/cards/white/d/9.png'),
  'w-d-8': require('../../assets/cards/white/d/8.png'),
  'w-d-7': require('../../assets/cards/white/d/7.png'),
  'w-d-6': require('../../assets/cards/white/d/6.png'),
  'w-d-5': require('../../assets/cards/white/d/5.png'),
  'w-d-4': require('../../assets/cards/white/d/4.png'),
  'w-d-3': require('../../assets/cards/white/d/3.png'),
  'w-d-2': require('../../assets/cards/white/d/2.png'),

  // OFFWHITE DIAMONDS
  'o-d-A': require('../../assets/cards/offwhite/d/A.png'),
  'o-d-K': require('../../assets/cards/offwhite/d/K.png'),
  'o-d-Q': require('../../assets/cards/offwhite/d/Q.png'),
  'o-d-J': require('../../assets/cards/offwhite/d/J.png'),
  'o-d-T': require('../../assets/cards/offwhite/d/T.png'),
  'o-d-9': require('../../assets/cards/offwhite/d/9.png'),
  'o-d-8': require('../../assets/cards/offwhite/d/8.png'),
  'o-d-7': require('../../assets/cards/offwhite/d/7.png'),
  'o-d-6': require('../../assets/cards/offwhite/d/6.png'),
  'o-d-5': require('../../assets/cards/offwhite/d/5.png'),
  'o-d-4': require('../../assets/cards/offwhite/d/4.png'),
  'o-d-3': require('../../assets/cards/offwhite/d/3.png'),
  'o-d-2': require('../../assets/cards/offwhite/d/2.png'),

  // GOLD DIAMONDS
  'g-d-K': require('../../assets/cards/gold/d/K.png'),
  'g-d-A': require('../../assets/cards/gold/d/A.png'),
  'g-d-Q': require('../../assets/cards/gold/d/Q.png'),
  'g-d-J': require('../../assets/cards/gold/d/J.png'),
  'g-d-T': require('../../assets/cards/gold/d/T.png'),
  'g-d-9': require('../../assets/cards/gold/d/9.png'),
  'g-d-8': require('../../assets/cards/gold/d/8.png'),
  'g-d-7': require('../../assets/cards/gold/d/7.png'),
  'g-d-6': require('../../assets/cards/gold/d/6.png'),
  'g-d-5': require('../../assets/cards/gold/d/5.png'),
  'g-d-4': require('../../assets/cards/gold/d/4.png'),
  'g-d-3': require('../../assets/cards/gold/d/3.png'),
  'g-d-2': require('../../assets/cards/gold/d/2.png'),


  //Heart

  'h-A': require('../../assets/cards/h/A.png'),
  'h-K': require('../../assets/cards/h/K.png'),
  'h-Q': require('../../assets/cards/h/Q.png'),
  'h-J': require('../../assets/cards/h/J.png'),
  'h-T': require('../../assets/cards/h/T.png'),
  'h-9': require('../../assets/cards/h/9.png'),
  'h-8': require('../../assets/cards/h/8.png'),
  'h-7': require('../../assets/cards/h/7.png'),
  'h-6': require('../../assets/cards/h/6.png'),
  'h-5': require('../../assets/cards/h/5.png'),
  'h-4': require('../../assets/cards/h/4.png'),
  'h-3': require('../../assets/cards/h/3.png'),
  'h-2': require('../../assets/cards/h/2.png'),

  // WHITE HEART
  'w-h-A': require('../../assets/cards/white/h/A.png'),
  'w-h-K': require('../../assets/cards/white/h/K.png'),
  'w-h-Q': require('../../assets/cards/white/h/Q.png'),
  'w-h-J': require('../../assets/cards/white/h/J.png'),
  'w-h-T': require('../../assets/cards/white/h/T.png'),
  'w-h-9': require('../../assets/cards/white/h/9.png'),
  'w-h-8': require('../../assets/cards/white/h/8.png'),
  'w-h-7': require('../../assets/cards/white/h/7.png'),
  'w-h-6': require('../../assets/cards/white/h/6.png'),
  'w-h-5': require('../../assets/cards/white/h/5.png'),
  'w-h-4': require('../../assets/cards/white/h/4.png'),
  'w-h-3': require('../../assets/cards/white/h/3.png'),
  'w-h-2': require('../../assets/cards/white/h/2.png'),

  // OFFWHITE HEART
  'o-h-A': require('../../assets/cards/offwhite/h/A.png'),
  'o-h-K': require('../../assets/cards/offwhite/h/K.png'),
  'o-h-Q': require('../../assets/cards/offwhite/h/Q.png'),
  'o-h-J': require('../../assets/cards/offwhite/h/J.png'),
  'o-h-T': require('../../assets/cards/offwhite/h/T.png'),
  'o-h-9': require('../../assets/cards/offwhite/h/9.png'),
  'o-h-8': require('../../assets/cards/offwhite/h/8.png'),
  'o-h-7': require('../../assets/cards/offwhite/h/7.png'),
  'o-h-6': require('../../assets/cards/offwhite/h/6.png'),
  'o-h-5': require('../../assets/cards/offwhite/h/5.png'),
  'o-h-4': require('../../assets/cards/offwhite/h/4.png'),
  'o-h-3': require('../../assets/cards/offwhite/h/3.png'),
  'o-h-2': require('../../assets/cards/offwhite/h/2.png'),

  // GOLD HEART
  'g-h-A': require('../../assets/cards/gold/h/A.png'),
  'g-h-K': require('../../assets/cards/gold/h/K.png'),
  'g-h-Q': require('../../assets/cards/gold/h/Q.png'),
  'g-h-J': require('../../assets/cards/gold/h/J.png'),
  'g-h-T': require('../../assets/cards/gold/h/T.png'),
  'g-h-9': require('../../assets/cards/gold/h/9.png'),
  'g-h-8': require('../../assets/cards/gold/h/8.png'),
  'g-h-7': require('../../assets/cards/gold/h/7.png'),
  'g-h-6': require('../../assets/cards/gold/h/6.png'),
  'g-h-5': require('../../assets/cards/gold/h/5.png'),
  'g-h-4': require('../../assets/cards/gold/h/4.png'),
  'g-h-3': require('../../assets/cards/gold/h/3.png'),
  'g-h-2': require('../../assets/cards/gold/h/2.png'),
};

